var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getAPIMap from "../api_map.js";
import axios from "axios";
import getIP from "../getIP.js";
import dayjs from "dayjs";
const IP = getIP();
/**
 * This method is used to get the balance amount of user
 * @param {*} param0
 * @returns
 */
export const getBalance = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1].token}`,
        },
    };
    var url = IP + getAPIMap("getWalletBalance");
    url = url.replace("{userId}", queryKey[2]);
    let response = yield axios.get(url, config);
    return response;
});
/**
 * This method is used to get the Quota units of user
 * @param {*} param0
 * @returns
 */
export const getQuota = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    var _b;
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1].token}`,
        },
    };
    let url = IP + getAPIMap("getQuotaBalance");
    url += "?productId=fb795a5100f957e7b81ep";
    url += `&date=${dayjs().format("YYYY-MM-DD")}`;
    url += `&orgId=${(_b = queryKey[1]) === null || _b === void 0 ? void 0 : _b.groupId[0]}`;
    let response = yield axios.get(url, config);
    return response;
});
/**
 * This method is used to get the balance amount of logged in user
 * @param {*} param0
 * @returns
 */
export const getMyBalance = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1].token}`,
        },
    };
    var url = IP + getAPIMap("getMyBalance");
    let response = yield axios.get(url, config);
    return response;
});
/**
 * This method is used to credit amount by PA to EA
 * @param {*} id
 * @param {*} amount
 * @param {*} userDetails
 * @returns
 */
export const creditAmount = (id_1, amount_1, userDetails_1, ...args_1) => __awaiter(void 0, [id_1, amount_1, userDetails_1, ...args_1], void 0, function* (id, amount, userDetails, ponumber = "") {
    const config = {
        headers: {
            Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
        },
    };
    // var url = IP + `/ngage_accounts/api/v3/accounts/users/${uid}`;
    var url = IP + getAPIMap("getCredit");
    var obj = { userId: id, amount: amount, txnId: ponumber };
    let response = yield axios.post(url, obj, config);
    return response;
});
export const creditAmountTransferType = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const config = {
        headers: {
            Authorization: `Bearer ${(_a = payload.userDetails) === null || _a === void 0 ? void 0 : _a.token}`,
        },
    };
    /*
    var url = IP + getAPIMap("updateCreditLimit");
    var obj = {
      userId: payload.payload.UserId,
      creditLimit: payload.payload.Amount.toString(),
    };
    let response = await axios.put(url, obj, config);
    */
    let url = IP + getAPIMap("topUp");
    let obj = {
        userId: payload.payload.UserId,
        amount: payload.payload.Amount.toString(),
        txnId: "",
        topUpType: "credit",
    };
    let response = yield axios.post(url, obj, config);
    return response;
});
export const debitAmountTransferType = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const config = {
        headers: {
            Authorization: `Bearer ${(_a = payload.userDetails) === null || _a === void 0 ? void 0 : _a.token}`,
        },
    };
    /*
    var url = IP + getAPIMap("updateCreditLimit");
    var obj = {
      userId: payload.payload.UserId,
      creditLimit: payload.payload.Amount.toString(),
    };
    let response = await axios.put(url, obj, config);
    */
    let url = IP + getAPIMap("topUp");
    let obj = {
        userId: payload.payload.UserId,
        amount: payload.payload.Amount.toString(),
        txnId: "",
        topUpType: "debit",
    };
    let response = yield axios.post(url, obj, config);
    return response;
});
export const resetWallet = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const config = {
        headers: {
            Authorization: `Bearer ${(_a = payload.userDetails) === null || _a === void 0 ? void 0 : _a.token}`,
        },
    };
    let url = IP + getAPIMap("resetWallet");
    url = url.replace("{userId}", payload.payload.userId);
    console.log("???[INFO] resetWallet payload", payload);
    let response = yield axios.put(url, {}, config);
    return response;
});
//airtel money
export const paymentGateway = (token, amount, phoneNum) => __awaiter(void 0, void 0, void 0, function* () {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    var url = IP + getAPIMap("paymentGateway");
    const body = {
        amount: amount,
        msisdn: phoneNum,
    };
    let response = yield axios.post(url, body, config);
    return response;
});
export const getUsers = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1].token}`,
        },
    };
    var url = IP + getAPIMap("getuser");
    let response = yield axios.get(url, config);
    return response;
});
/**
 * This method is used to debit amount from EA by PA
 * @param {*} id
 * @param {*} amount
 * @param {*} userDetails
 * @returns
 */
export const debitAmount = (id_1, amount_1, userDetails_1, ...args_1) => __awaiter(void 0, [id_1, amount_1, userDetails_1, ...args_1], void 0, function* (id, amount, userDetails, ponumber = "") {
    const config = {
        headers: {
            Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
        },
    };
    var url = IP + getAPIMap("debit");
    var obj = { userId: id, amount: amount, txnId: ponumber };
    try {
        let response = yield axios.post(url, obj, config);
        return response;
    }
    catch (error) {
        return Promise.reject(error);
    }
});
/**
 * This method is used to transfer amount from EA to EU
 * @param {*} srcId
 * @param {*} destId
 * @param {*} amount
 * @param {*} userDetails
 * @returns
 */
export const transferAmount = (_a) => __awaiter(void 0, [_a], void 0, function* ({ srcId, destId, amount, userDetails, }) {
    const config = {
        headers: {
            Authorization: `Bearer ${userDetails === null || userDetails === void 0 ? void 0 : userDetails.token}`,
        },
    };
    var url = IP + getAPIMap("transfer");
    var obj = { srcUser: srcId, destUser: destId, amount: amount };
    try {
        let response = yield axios.post(url, obj, config);
        return response;
    }
    catch (error) {
        return Promise.reject(error);
    }
});
export function getEnterpriseList(_a) {
    return __awaiter(this, arguments, void 0, function* ({ queryKey }) {
        const config = {
            headers: {
                Authorization: `Bearer ${queryKey[1].token}`,
            },
        };
        var url = IP + getAPIMap("listAccounts");
        let response = yield axios.get(url, config);
        return response;
    });
}
export function getBuffer(_a) {
    return __awaiter(this, arguments, void 0, function* ({ queryKey }) {
        const config = {
            headers: {
                Authorization: `Bearer ${queryKey[1].token}`,
            },
        };
        let url = IP + getAPIMap("getBuffer");
        url = url.replace("{userId}", queryKey[1].sub);
        let response = yield axios.get(url, config);
        return response;
    });
}
export const updateBuffer = (_a) => __awaiter(void 0, [_a], void 0, function* ({ userId, buffer, token }) {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const url = IP + getAPIMap("updateBuffer");
    const body = { buffer, userId };
    const response = yield axios.put(url, body, config);
    return response;
});
export const updateCreditLimit = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const config = {
        headers: {
            Authorization: `Bearer ${payload.userDetails.token}`,
        },
    };
    var url = IP + getAPIMap("updateCreditLimit");
    var obj = {
        userId: payload.userId,
        creditLimit: payload.creditLimit.toString(),
        billingType: "POSTPAID"
    };
    let response = yield axios.put(url, obj, config);
    return response;
});
